<template>
  <div class="dt-menu">
    <label>
      {{ $t('folders_list.users') }}
    </label>
    <multi-select :getter='getUsers' v-model='selected' />
    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../shared/_infinite_multi_select'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    data() {
      return {
        selected: []
      }
    },
    computed: {
      selectedIds() {
        return this.selected.map(u => u.id)
      },
    },
    methods: {
      filter() {
        const newQuery = Object.assign({}, this.query, { page: 1, 'filters[user_id_in]': this.selectedIds })
        this.$router.push({ query: newQuery })
      },
      getUsers(params) {
        return this.listStore.getUsers(Object.assign({ 'filters[status_eq]': 'active' }, params))
      },
    }
  }
</script>
<style lang="sass" scoped>
  .dt-menu
    width: 200px
    padding: 10px
    .float-right
      margin-top: 10px
    select
      margin-bottom: 10px
  label
    display: block
</style>
